var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotstartedIcon = function SvgNotstartedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 45,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CCCBC9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M22.5 41.25c10.313 0 18.75-8.438 18.75-18.75 0-10.313-8.438-18.75-18.75-18.75-10.313 0-18.75 8.438-18.75 18.75 0 10.313 8.438 18.75 18.75 18.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#A6A5A3",
    d: "M56.667 22a2.667 2.667 0 1 0-5.334 0 2.667 2.667 0 0 0 5.334 0ZM74 22v-.5H54v1h20V22Z"
  })));
};
export default SvgNotstartedIcon;